import { useTranslation } from "react-i18next";

import { Body, Heading } from "./empty-item-component-styles";

type Props = {
  includesSearch: boolean;
  partsCount: number;
  tagsCount: number;
};

export default function EmptyItem(props: Props) {
  const { tagsCount, partsCount, includesSearch } = props;
  const { t } = useTranslation();

  const message = [
    props.tagsCount &&
      t("schedule.selected_tag", {
        count: props.tagsCount,
      }),
    props.partsCount &&
      t("schedule.selected_segment", { count: props.partsCount }),
    props.includesSearch && t("schedule.search"),
  ]
    .filter(Boolean)
    .reduce((accum, item, index, arr) => {
      if (!accum) {
        return item;
      }

      accum += index === arr.length - 1 ? " and " : ", ";
      accum += item;

      return accum;
    }, ``);

  if (!includesSearch && !tagsCount && !partsCount) {
    return null;
  }

  return (
    <>
      <Heading>{t("schedule.no-results")}</Heading>
      <Body>{`${t("schedule.unable-to-find-segments")} ${message}`}</Body>
    </>
  );
}
